
export default {
    props: {
        canGoBack: { type: Boolean, default: false },
        totalSteps: { type: Number, default: 5 },
        allowSave: { type: Boolean, default: true },
        hideContinue: { type: Boolean, default: false },
        continueDisabled: { type: Boolean, default: false },
        continueLabel: { type: String, default: 'Continue' },
        error: { type: String, default: '' },
        // Shows a spinner in the continue button (e.g. during the /book POST).
        loading: { type: Boolean, default: false },
        loadingLabel: { type: String, default: '' },
    },
}
